import { FC } from 'react';
import clsx from 'clsx';
import { ILayoutBase } from '../../types';
import Header from './header';
import Footer from './footer';
import styles from './styles.module.css';

const LayoutLimbic: FC<ILayoutBase> = props => {
  const { title = 'Clinic Admin Portal', subtitle, children } = props;

  return (
    <div className={styles.wrapper}>
      <Header />
      <div className={styles.container}>
        <section className={clsx('section', styles.titleWrapper)}>
          <span className={styles.title}>{title}</span>
          {Boolean(subtitle) && <span className={styles.subtitle}>{subtitle}</span>}
        </section>
        <section className={clsx('section', styles.contentWrapper)}>
          <div className="container">{children}</div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default LayoutLimbic;
